export type SearchStatus = "idle" | "loading" | "stalled" | "error";

export const shouldShowSearchResultCount = (status: SearchStatus, isArtificial: boolean) => {
  return status !== "loading" && status !== "stalled" && !isArtificial;
};

export const shouldShowEmptySearchState = (status: SearchStatus, isArtificial: boolean, resultCount: number) => {
  return shouldShowSearchResultCount(status, isArtificial) && resultCount === 0;
};
